import React from 'react';
import PropTypes from 'prop-types';

const BettingOddsCell = ({ row, cell, cellProps }) => {
    if (row.allCells[0].value.eligible) {
        if (cell.value === 0) {
            return (
                <td {...cellProps} className="stats-table__betting-odds-cell" />
            );
        }

        const formattedOdds = new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD'
        }).format(cell.value);

        return (
            <td {...cellProps} className="stats-table__betting-odds-cell">
                {row.original.bettingOddsUrl &&
                row.original.bettingOddsUrl !== '' ? (
                    <a
                        href={row.original.bettingOddsUrl}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {formattedOdds}
                    </a>
                ) : (
                    <span>{formattedOdds}</span>
                )}
            </td>
        );
    }

    return (
        <td {...cellProps} className="stats-table__betting-odds-cell">
            <span>–</span>
        </td>
    );
};

export default BettingOddsCell;

BettingOddsCell.propTypes = {
    row: PropTypes.object,
    cell: PropTypes.object,
    cellProps: PropTypes.object
};
